import { createRouter, createWebHistory } from "vue-router";
import AccueilView from "../views/AccueilView.vue";
import FicheArticleView from "../views/FicheArticleView.vue";
import FicheAffaireView from "../views/FicheAffaireView.vue";
import FicheUtilisateurView from "../views/FicheUtilisateurView.vue";
import DemandeView from "../views/DemandeView.vue";
import DemandeArchiveView from "../views/DemandeArchiveView.vue";
import InscriptionView from "../views/InscriptionView.vue";
import GererEspaces from "../views/GererEspaces.vue";
import AffaireView from "../views/AffaireView.vue";
import EvolAffaireView from "../views/EvolAffaireView.vue";
import AchatsView from "../views/AchatsView.vue";
import UtilisateursView from "../views/UtilisateursView.vue";
import RecapView from "../views/RecapView.vue";
import InventaireView from "../views/InventaireView.vue";
import RecapInventaireView from "../views/RecapInventaireView.vue";
import ProductionView from "../views/ProductionView.vue";
import FichiersClientView from "../views/FichiersClientView.vue";
import FichiersArticleView from "../views/FichiersArticleView.vue";
import FichiersAffaireView from "../views/FichiersAffaireView.vue";
import FichiersMagasinView from "../views/FichiersMagasinView.vue";
import AffaireSoldeeView from "../views/AffaireSoldeeView.vue";
import FicheAffaireSoldeeView from "../views/FicheAffaireSoldeeView.vue";
import CommandesView from "../views/CommandesView.vue";
import ScanDocumentsView from "../views/scan-document/ScanDocumentsView.vue";
import AdminView from "../views/AdminView.vue";
import MesHeuresView from "../views/MesHeuresView.vue";
import VueCookies from "vue-cookies";

const requireAuth = (to, from, next) => {
  if (VueCookies.get("token")) {
    next();
  } else {
    next("/");
  }
};

// Rôles autorisés pour le module scan-documents (GED) : admin (accès complet),
// production / be / gestion (lecture des BL uniquement),
// comptabilite (factures uniquement)
const SCAN_DOC_ROLES = ['admin', 'production', 'be', 'gestion', 'comptabilite'];

const requireScanDocAccess = (to, from, next) => {
  const token = VueCookies.get("token");
  const role = VueCookies.get("role");

  if (!token) {
    next("/");
  } else if (!SCAN_DOC_ROLES.includes(role)) {
    next("/?page=1&searchTerm=&selectedMag=&selectedFourn=&showOnlyAvailable=&sortColumn=&sortDirection=");
  } else {
    next();
  }
};

const routes = [
  {
    path: "/",
    name: "accueil",
    component: AccueilView,
  },
  {
    path: "/article/:designation/:designation2/:designation3/:codeArticle/:magasin/:currentPage/:searchTerm/:selectedFourn/:selectedMag/:showOnlyAvailable/:sortColumn/:sortDirection",
    name: "article",
    component: FicheArticleView,
    beforeEnter: requireAuth,
  },
  {
    path: "/article-achat/:designation/:designation2/:designation3/:codeArticle/:magasin/:currentPage/:searchTerm/:selectedFourn/:selectedMag/:sortColumn/:sortDirection",
    name: "article-achat",
    component: FicheArticleView,
    beforeEnter: requireAuth,
  },
  {
    path: "/affaire/:designation/:designation2/:designation3/:naf/:client/:currentPage/:searchTerm/:selectedFilter/:selectedClient/:selectedCde/:sortColumn/:sortDirection",
    name: "affaire",
    component: FicheAffaireView,
    beforeEnter: requireAuth,
  },
  {
    path: "/affaire-soldee/:designation/:designation2/:designation3/:naf/:client/:currentPage/:searchTerm/:selectedClient/:sortColumn/:sortDirection",
    name: "affaire-soldee",
    component: FicheAffaireSoldeeView,
    beforeEnter: requireAuth,
  },
  {
    path: "/utilisateur/:nom/:prenom/:role/:currentPage/:searchTerm",
    name: "utilisateur",
    component: FicheUtilisateurView,
    beforeEnter: requireAuth,
  },
  {
    path: "/ajout-compte/",
    name: "ajout-compte",
    component: InscriptionView,
    beforeEnter: requireAuth,
  },
  {
    path: "/gerer-espaces/",
    name: "gerer-espaces",
    component: GererEspaces,
    beforeEnter: requireAuth,
  },
  {
    path: "/demandes/",
    name: "demandes",
    component: DemandeView,
    beforeEnter: requireAuth,
  },
  {
    path: "/demandes-archives/",
    name: "demandes-archives",
    component: DemandeArchiveView,
    beforeEnter: requireAuth,
  },
  {
    path: "/affaires/",
    name: "affaires",
    component: AffaireView,
    beforeEnter: requireAuth,
  },
  {
    path: "/evol-affaires/",
    name: "evol-affaires",
    component: EvolAffaireView,
    beforeEnter: requireAuth,
  },
  {
    path: "/affaires-soldees/",
    name: "affaires-soldees",
    component: AffaireSoldeeView,
    beforeEnter: requireAuth,
  },
  {
    path: "/achats/",
    name: "achats",
    component: AchatsView,
    beforeEnter: requireAuth,
  },
  {
    path: "/utilisateurs/",
    name: "utilisateurs",
    component: UtilisateursView,
    beforeEnter: requireAuth,
  },
  {
    path: "/admin/",
    name: "admin",
    component: AdminView,
    beforeEnter: requireAuth,
  },
  {
    path: "/recap/",
    name: "recap",
    component: RecapView,
    beforeEnter: requireAuth,
  },
  {
    path: "/inventaire/",
    name: "inventaire",
    component: InventaireView,
    beforeEnter: requireAuth,
  },

  {
    path: "/inventaire-recap/:id/:date/:nom/:prenom/",
    name: "inventaire-recap",
    component: RecapInventaireView,
    beforeEnter: requireAuth,
  },
  {
    path: "/production/:idClient/",
    name: "production",
    component: ProductionView,
    beforeEnter: requireAuth,
  },

  {
    path: "/mes-heures",
    name: "mes-heures",
    component: MesHeuresView,
    beforeEnter: requireAuth,
  },

  {
    path: "/fichiers-client/:client/",
    name: "fichiers-client",
    component: FichiersClientView,
    beforeEnter: requireAuth,
  },
  {
    path: "/fichiers-affaire/:naf/",
    name: "fichiers-affaire",
    component: FichiersAffaireView,
    beforeEnter: requireAuth,
  },
  {
    path: "/fichiers-article/:codeArticle/",
    name: "fichiers-article",
    component: FichiersArticleView,
    beforeEnter: requireAuth,
  },
  {
    path: "/fichiers-magasin/:magasin/",
    name: "fichiers-magasin",
    component: FichiersMagasinView,
    beforeEnter: requireAuth,
  },
  {
    path: "/commandes-en-cours/:client/",
    name: "commandes-en-cours",
    component: CommandesView,
    beforeEnter: requireAuth,
  },
  {
    path: "/scan-documents/",
    name: "scan-documents",
    component: ScanDocumentsView,
    beforeEnter: requireScanDocAccess,
  },
];
const router = createRouter({
  history: createWebHistory(`/espace-client/`),
  routes,
});

export default router;
